import { Action } from '@ngrx/store';
import { DealSummaryView } from 'src/app/shared/model/view-model/deal-summary-view';
import { SuperMenuItem } from 'src/app/core/state/actions/supermenu.actions';
import { DealRoute } from '../../../../shared/model/api';
import { RealtimeDeal } from 'src/app/shared/model/api/realtime-deal';
import { SocketMessage } from 'src/app/core/services/websocket-manager.service';
import { MonroneyLabel } from 'src/app/shared/model/api/MonroneyLabel';
/**
 * Summary Types
 */
export const SUMMARY_ACTION = {
  SET_SELECTED: '[Summary] SET_SELECTED',
  SET_CART: '[Summary] SET_CART',
  REMOVE_CART: '[Summary] REMOVE_CART',
  SET_NEW_VINS: '[Summary] SET_NEW_VINS',
  SET_LAST_SEEN_VEHICLE_VIN: '[Summary] SET_LAST_SEEN_VEHICLE_VIN',
  LOAD: '[Summary] Load',
  LOADED: '[Summary] Loaded',
  OPEN_DIALOG: '[Summary] SUMMARY_OPEN_DIALOG',
  CLOSE_DIALOG: '[Summary] SUMMARY_CLOSE_DIALOG',
  LOAD_DATA : '[Summary] LOAD_DATA',
  LOAD_DATA_SUCCESS : '[Summary] LOAD_DATA_SUCCESS',
  REALTIME_LOAD_DATA : '[Summary] REALTIME_LOAD_DATA',
  REALTIME_LOAD_DATA_SUCCESS : '[Summary] REALTIME_LOAD_DATA_SUCCESS',
  REALTIME_DEAL_NEW_SOCKET_MESSAGE : '[Summary] REALTIME_DEAL_NEW_SOCKET_MESSAGE',
  REALTIME_SET_COMMENT_READ: '[Summary] REALTIME_SET_COMMENT_READ',
  APPLY_FILTER_SUCCESS: '[Summary] APPLY_FILTER_SUCCESS',
  //SUPER_MENU_DATA: '[Summary] SUPER_MENU_DATA',
  //UPDATE_VIEW_MODE: '[Summary] UPDATE_VIEW_MODE',
  CHANGE_ACTIVE_VIEW : '[Summary] CHANGE_ACTIVE_VIEW',
  WRITEUPGRID_SHOWHIDDEN : '[Summary] WRITEUPGRID_SHOWHIDDEN',
  UPDATE_HIDEUNHIDE_STATUS : '[Summary] UPDATE_HIDEUNHIDE_STATUS',
  UPDATE_HIDEUNHIDE_STATUS_SUCESS : '[Summary] UPDATE_HIDEUNHIDE_STATUS_SUCESS',
  MONRONEY_LABEL_LOAD_DATA : '[Summary] MONRONEY_LABEL_LOAD_DATA',
  MONRONEY_LABEL_LOAD_DATA_SUCCESS : '[Summary] MONRONEY_LABEL_LOAD_DATA_SUCCESS',
  MONRONEY_LABEL_LOAD_DATA_FAIL : '[Summary] MONRONEY_LABEL_LOAD_DATA_FAIL',
  LOAD_DEALER_DATA : '[Summary] LOAD_DEALER_DATA',
  LOAD_DEALER_DATA_SUCCESS: '[Summary] LOAD_DEALER_DATA_SUCCESS',
  USED_VEHICLE_LOAD_DATA: '[Summary] USED_VEHICLE_LOAD_DATA',
  USED_VEHICLE_LOAD_DATA_SUCCESS: '[Summary] USED_VEHICLE_LOAD_DATA_SUCCESS',
  USED_VEHICLE_LOAD_DATA_FAIL: '[Summary] USED_VEHICLE_LOAD_DATA_FAIL',
  MONRONEY_LABEL_RESET_DATA: '[Summary] MONRONEY_LABEL_RESET_DATA',
  REPRINT_DECLINATION_FORM_LOAD_DATA : '[Summary] REPRINT_DECLINATION_FORM_LOAD_DATA',
  REPRINT_DECLINATION_FORM_LOAD_DATA_SUCCESS : '[Summary] REPRINT_DECLINATION_FORM_LOAD_DATA_SUCCESS',
  REPRINT_DECLINATION_FORM_LOAD_DATA_FAIL : '[Summary] REPRINT_DECLINATION_FORM_LOAD_DATA_FAIL',
  DEAL_OFFERS_LOAD_DATA : '[Summary] DEAL_OFFERS_LOAD_DATA',
  DEAL_OFFERS_LOAD_DATA_SUCCESS : '[Summary] DEAL_OFFERS_LOAD_DATA_SUCCESS',
  DEAL_OFFERS_LOAD_DATA_FAIL : '[Summary] DEAL_OFFERS_LOAD_DATA_FAIL',
  V_SPEC_LOAD_DATA : '[Summary] V_SPEC_LOAD_DATA',
  V_SPEC_LOAD_DATA_SUCCESS : '[Summary] V_SPEC_LOAD_DATA_SUCCESS',
  V_SPEC_LOAD_DATA_FAIL : '[Summary] V_SPEC_LOAD_DATA_FAIL',
  GET_PROTECTION_PRODUCTS: '[Summary] GET_PROTECTION_PRODUCTS',
  GET_PROTECTION_PRODUCTS_SUCCESS: '[Summary] GET_PROTECTION_PRODUCTS_SUCCESS',
  GET_PROTECTION_PRODUCTS_FAIL: '[Summary] GET_PROTECTION_PRODUCTS_FAIL',
  RESET_PROTECTION_PRODUCTS: '[Summary] RESET_PROTECTION_PRODUCTS',
  OPEN_VSPEC_IN_BROWSER : '[Summary] OPEN_VSPEC_IN_BROWSER',
  OPEN_VSPEC_IN_BROWSER_SUCCESS : '[Summary] OPEN_VSPEC_IN_BROWSER_SUCCESS',
  OPEN_VSPEC_IN_BROWSER_FAIL : '[Summary] OPEN_VSPEC_IN_BROWSER_FAIL',
  RESET_VSPEC_TOKEN: '[Summary] RESET_VSPEC_TOKEN',
  CREATE_VSPEC_CUSTOM_LANDING: '[Summary] CREATE_VSPEC_CUSTOM_LANDING',
  BASE_64_DATA: '[Summary] BASE_64_DATA',
  REPRINT_DECLINATION_FORM_RESET_DATA: '[Summary] REPRINT_DECLINATION_FORM_RESET_DATA',
  SET_MASTER: '[Summary] GRID_CUSTOM_SCHEMA_SET_MASTER',
  APPLY: '[Summary] GRID_CUSTOM_SCHEMA_APPLY',
};

/**
 * SummarySetSelected
 */
export class SummarySetSelected implements Action {
  public readonly type: string = SUMMARY_ACTION.SET_SELECTED;
  constructor(public payload?: any) {}
}
/**
 * SummarySetNewVins
 */
export class SummarySetNewVins implements Action {
  public readonly type: string = SUMMARY_ACTION.SET_NEW_VINS;
  constructor(public payload: string[]) {}
}
/**
 * SummarySetCart
 */
export class SummarySetCart implements Action {
  public readonly type: string = SUMMARY_ACTION.SET_CART;
  constructor(public payload?: any) {}
}
/**
 * SummarySetLastSeenVehicleVin
 */
export class SummarySetLastSeenVehicleVin implements Action {
  public readonly type: string = SUMMARY_ACTION.SET_LAST_SEEN_VEHICLE_VIN;
  constructor(public payload: string) {}
}

/**
 * SummaryRemoveFromCart
 */
export class SummaryRemoveFromCart implements Action {
  public readonly type: string = SUMMARY_ACTION.REMOVE_CART;
  constructor(public payload?: any) {}
}

/**
 * SummaryOnLoad
 */
export class SummaryOnLoad implements Action {
  public readonly type: string = SUMMARY_ACTION.LOAD;
  constructor() {}
}

/**
 * SummaryOnLoaded
 */
export class SummaryOnLoaded implements Action {
  public readonly type: string = SUMMARY_ACTION.LOADED;
  constructor(public payload?: any) {}
}

/**
 * SummaryOpenDialog
 */
export class SummaryOpenDialog implements Action {
  public readonly type: string = SUMMARY_ACTION.OPEN_DIALOG;
  constructor(public payload: any) {
  }
}

export class SummaryCloseDialog implements Action {
  public readonly type: string = SUMMARY_ACTION.CLOSE_DIALOG;
  constructor() {}
}

export class SummaryLoadData implements Action {
  public readonly type: string = SUMMARY_ACTION.LOAD_DATA;
  constructor(public payload?: any) {}
}

export class SummaryOnDataLoadSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.LOAD_DATA_SUCCESS;
  constructor(public payload: DealSummaryView) {}
}

export class SummaryRealtimeLoadData implements Action {
  public readonly type: string = SUMMARY_ACTION.REALTIME_LOAD_DATA;
  constructor() {}
}

export class SummaryOnRealtimeLoadDataSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.REALTIME_LOAD_DATA_SUCCESS;
  constructor(public payload: RealtimeDeal[]) {}
}

export class SummaryOnRealtimeDealNewSocketMessage implements Action {
  public readonly type: string = SUMMARY_ACTION.REALTIME_DEAL_NEW_SOCKET_MESSAGE;
  constructor(public payload: SocketMessage) {}
}
export class SummaryOnRealtimeCommentOpened implements Action {
  public readonly type: string = SUMMARY_ACTION.REALTIME_SET_COMMENT_READ;
  constructor(public payload: string) {}
}

export class SummaryChangeActiveView implements Action {
  public readonly type: string = SUMMARY_ACTION.CHANGE_ACTIVE_VIEW;
  constructor(public payload: SuperMenuItem) {}
}

export class SummaryToggleWriteupGridShowHidden implements Action {
  public readonly type: string = SUMMARY_ACTION.WRITEUPGRID_SHOWHIDDEN;
  constructor() {}
}

export class SummaryUpdateHideUnhideStatus implements Action {
  public readonly type: string = SUMMARY_ACTION.UPDATE_HIDEUNHIDE_STATUS;
  constructor(public payload: string[]) {}
  
}
export class SummaryUpdateHideUnhideSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.UPDATE_HIDEUNHIDE_STATUS_SUCESS;
  constructor(public payload: string[]) {}
  
}

/**
 * Summary Load Monroney Label Data
*/
export class SummaryMonroneyLabelLoadData implements Action {
  public readonly type: string = SUMMARY_ACTION.MONRONEY_LABEL_LOAD_DATA;
  constructor(public payload: MonroneyLabel) {}
}

/**
 * Summary Load Monroney Label Data Success
*/
export class SummaryOnMonroneyLabelSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.MONRONEY_LABEL_LOAD_DATA_SUCCESS;
  constructor(public payload: any) {}
}

/**
 * Summary Load Monroney Label Data Failure
*/
export class SummaryOnMonroneyLabelFail implements Action {
  public readonly type: string = SUMMARY_ACTION.MONRONEY_LABEL_LOAD_DATA_FAIL;
  constructor(public payload: any) {}
}

/**
 * Summary Monroney Label Data Reset
*/
export class SummaryMonroneyaLabelReset implements Action {
  public readonly type: string = SUMMARY_ACTION.MONRONEY_LABEL_RESET_DATA;
  constructor() {}
}

/**
 * Summary Load Used Vehicle Data
*/
export class SummaryusedVehicleLoadData implements Action {
  public readonly type: string = SUMMARY_ACTION.USED_VEHICLE_LOAD_DATA;
  constructor(public payload: any) {}
}

/**
 * Summary Load Used Vehicle Data Success
*/
export class SummaryUsedVehicleDataSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.USED_VEHICLE_LOAD_DATA_SUCCESS;
  constructor(public payload: any) {}
}

/**
 * Summary Load Used Vehicle Data Failure
*/
export class SummaryUsedVehicleDataFail implements Action {
  public readonly type: string = SUMMARY_ACTION.USED_VEHICLE_LOAD_DATA_FAIL;
  constructor(public payload: any) {}
}

/**
 * Summary Reprint Declination Form Data 
*/
export class SummaryReprintDeclinationFormLoadData implements Action {
  public readonly type: string = SUMMARY_ACTION.REPRINT_DECLINATION_FORM_LOAD_DATA;
  constructor(public payload: any) {}
}

/**
 * Summary Declination Form Data Reset 
*/
export class SummaryDeclinationFormReset implements Action {
  public readonly type: string = SUMMARY_ACTION.REPRINT_DECLINATION_FORM_RESET_DATA;
  constructor() {}
}

/**
 * Summary Offers Data 
*/
export class SummaryDealOffersLoadData implements Action {
  public readonly type: string = SUMMARY_ACTION.DEAL_OFFERS_LOAD_DATA;
  constructor(public payload: any) {}
}

/**
 * Summary Offers Data Success
*/
export class SummaryDealOffersLoadDataSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.DEAL_OFFERS_LOAD_DATA_SUCCESS;
  constructor(public payload: any) {}
}

/**
 * Summary Offers Data Failure
*/
export class SummaryDealOffersLoadDataFail implements Action {
  public readonly type: string = SUMMARY_ACTION.DEAL_OFFERS_LOAD_DATA_FAIL;
  constructor(public payload: any) {}
}

/**
 * Summary Reprint Declination Form Data Success
*/
export class SummaryReprintDeclinationFormDataSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.REPRINT_DECLINATION_FORM_LOAD_DATA_SUCCESS;
  constructor(public payload: any) {}
}

/**
 * Summary Reprint Declination Form Data Failure
*/
export class SummaryReprintDeclinationFormDataFail implements Action {
  public readonly type: string = SUMMARY_ACTION.REPRINT_DECLINATION_FORM_LOAD_DATA_FAIL;
  constructor(public payload: any) {}
}

/**
 * Summary Open V-Spec in Browser
*/
export class SummaryOpenVSpecInBrowser implements Action {
  public readonly type: string = SUMMARY_ACTION.OPEN_VSPEC_IN_BROWSER;
  constructor(public payload: any) {}
}

/**
 * Summary Open V-Spec in Browser Success
*/
export class SummaryOpenVSpecInBrowserSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.OPEN_VSPEC_IN_BROWSER_SUCCESS;
  constructor(public payload: any) {}
}

/**
 * Summary Open V-Spec in Browser Failure
*/
export class SummaryOpenVSpecInBrowserFail implements Action {
  public readonly type: string = SUMMARY_ACTION.OPEN_VSPEC_IN_BROWSER_FAIL;
  constructor(public payload: any) {}
}

export class SummaryGetProtectionProducts implements Action {
  public readonly type: string = SUMMARY_ACTION.GET_PROTECTION_PRODUCTS;
  constructor(public payload: any) {}
}
export class SummaryGetProtectionProductsSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.GET_PROTECTION_PRODUCTS_SUCCESS;
  constructor(public payload: any) {}
}
export class SummaryGetProtectionProductsFail implements Action {
  public readonly type: string = SUMMARY_ACTION.GET_PROTECTION_PRODUCTS_FAIL;
  constructor(public payload: any) {}
}

/**
 * Summary Reset V-Spec Token
*/
export class SummaryResetVSpecToken implements Action {
  public readonly type: string = SUMMARY_ACTION.RESET_VSPEC_TOKEN;
  constructor() {}
}

/**
 * Summary Create V-Spec Custom Landing
*/
export class SummaryCreateVSpecCustomLanding implements Action {
  public readonly type: string = SUMMARY_ACTION.CREATE_VSPEC_CUSTOM_LANDING;
  constructor(public payload: any) {}
}

/**
 * Summary Reset V-Spec Token
*/
export class SummaryResetProtectionProductsData implements Action {
  public readonly type: string = SUMMARY_ACTION.RESET_PROTECTION_PRODUCTS;
  constructor() {}
}



// export class SelectedWriteupRoute implements Action {
//   public readonly type: string = SUMMARY_ACTION.SELECTED_WRITEUP_ROUTE;
//   constructor(public payload: DealRoute) {}
// }
 
//
// SDL: why ?
//
// export class ApplyFilterSuccessAction implements Action {
//   public readonly type: string = SUMMARY_ACTION.APPLY_FILTER_SUCCESS;
//   constructor(public payload: any) { }
// }

/**
 * Switching the tab and populate the value in grid
 */
// export class SuperMenuData{
//   public readonly type:string = SUMMARY_ACTION.SUPER_MENU_DATA;
//   constructor(public payload:any){console.log(" summart action ==> ", this.payload);}
// }

/**
 * Summary v-spec download 
*/
export class SummaryVspec implements Action {
  public readonly type: string = SUMMARY_ACTION.V_SPEC_LOAD_DATA;
  constructor(public payload: any) {}
}

/**
 * Summary v-spec download Success
*/
export class SummaryVspecSuccess implements Action {
  public readonly type: string = SUMMARY_ACTION.V_SPEC_LOAD_DATA_SUCCESS;
  constructor(public payload: any) {}
}

/**
 * Summary v-spec download Failure
*/
export class SummaryVspecFail implements Action {
  public readonly type: string = SUMMARY_ACTION.V_SPEC_LOAD_DATA_FAIL;
  constructor(public payload: any) {}
}
/**
 * Summary object with Base64Data Action
*/
export class SummaryBase64Data implements Action {
  public readonly type: string = SUMMARY_ACTION.BASE_64_DATA;
  constructor(public payload: any) {}
}

export class GridCustomSchemaSetMaster implements Action {
  public readonly type: string = SUMMARY_ACTION.SET_MASTER;
  constructor(public payload? : {
    masterColumns: any[]
  }) {}
}

export class GridCustomSchemaApply implements Action {
  public readonly type: string = SUMMARY_ACTION.APPLY;
  constructor(public payload?: {
    userColumns: any[]}) {}
}

export type Any =
  | SummarySetSelected
  | SummarySetCart
  | SummaryRemoveFromCart
  | SummarySetNewVins
  | SummaryOnLoad
  | SummaryOnLoaded
  | SummaryOpenDialog
  | SummaryCloseDialog
  | SummaryLoadData
  | SummaryOnDataLoadSuccess
  | SummaryChangeActiveView
  | SummaryToggleWriteupGridShowHidden
  | SummaryUpdateHideUnhideStatus
  | SummaryUpdateHideUnhideSuccess
  | SummaryMonroneyLabelLoadData
  | SummaryOnMonroneyLabelSuccess
  | SummaryOnMonroneyLabelFail
  | SummaryusedVehicleLoadData
  | SummaryUsedVehicleDataSuccess
  | SummaryUsedVehicleDataFail
  | SummaryMonroneyaLabelReset
  | SummaryReprintDeclinationFormLoadData
  | SummaryReprintDeclinationFormDataSuccess
  | SummaryReprintDeclinationFormDataFail
  | SummaryDealOffersLoadData
  | SummaryDealOffersLoadDataSuccess
  | SummaryDealOffersLoadDataFail
  | SummaryVspec
  | SummaryVspecSuccess
  | SummaryVspecFail
  | SummaryOpenVSpecInBrowser
  | SummaryOpenVSpecInBrowserSuccess
  | SummaryOpenVSpecInBrowserFail
  | SummaryResetVSpecToken
  | SummaryCreateVSpecCustomLanding
  | SummaryBase64Data
  | SummaryDeclinationFormReset
  | SummaryGetProtectionProducts
  | SummaryGetProtectionProductsSuccess
  | SummaryGetProtectionProductsFail
  | SummaryResetProtectionProductsData
  | GridCustomSchemaSetMaster
  | GridCustomSchemaApply;
